import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import { faCodeBranch } from '@fortawesome/pro-solid-svg-icons/faCodeBranch';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { PendingProviderPropType, ProviderPropType } from '../types';
import { isProviderNotActive } from '../utils';
import messages from './messages';
import style from './style.module.less';

export const ConditionalPackingSlipProvider = ({ provider }) => {
  // if provider is deactivated
  // could be inactive and pending at the same time (when the provider is invited but not accepted) so we need to check for both
  if (isProviderNotActive(provider)) {
    return null;
  }

  if (!provider.packingSlipSharing) {
    return null;
  }

  return (
    <SharedPackingSlipsStatus isCompatible={!provider.packingSlipSharing.notSupported} status={provider.packingSlipSharing.isEnabled} />
  );
};

ConditionalPackingSlipProvider.propTypes = {
  provider: PropTypes.oneOfType([PendingProviderPropType, ProviderPropType]).isRequired,
};

const SharedPackingSlipsStatus = ({ isCompatible, status = false }) => {
  return (
    <>
      {isCompatible && status && (
        <div>
          <FontAwesomeIcon className={style['status-icon']} icon={faCheck} />
          <p className={style['status-text']}>
            <FormattedMessage {...messages.sharedStatus} />
          </p>
        </div>
      )}
      {!isCompatible && (
        <div>
          <FontAwesomeIcon className={style['status-icon-not-compatible']} icon={faCodeBranch} />
          <p className={style['status-text']}>
            <FormattedMessage {...messages.notCompatible} />
          </p>
        </div>
      )}
    </>
  );
};

SharedPackingSlipsStatus.propTypes = {
  isCompatible: PropTypes.bool.isRequired,
  status: PropTypes.bool,
};
